import React, { RefObject } from 'react'

export type Size = {
  width: number
  height: number
  isMobile: boolean
}

function getSize(el: any) {
  const bbox = el.getBoundingClientRect()
  return {
    width: bbox.width,
    height: bbox.height,
    isMobile: window.innerWidth < 550 // browsercheck.isMobile
  }
}

function useSize(): [RefObject<HTMLDivElement>, Size] {
  const container = React.useRef(null)
  const [size, setSize] = React.useState<Size>({
    width: 60,
    height: 0,
    isMobile: true
  })
  const handleResize = React.useCallback(
    function handleResize() {
      if (container.current !== null) {
        setSize(getSize(container.current))
      }
    },
    [container]
  )
  React.useLayoutEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return function() {
      window.removeEventListener('resize', handleResize)
    }
  }, [container])

  return [container, size]
}

export default useSize
